import { Fragment, useCallback } from 'react'

import useTranslations from '../../../hooks/useTranslations'
import ANTDTable from '../../../shared/antd/ANTDTable'
import { isArray } from '../../../utils/javascript'
import { provenanceTitles } from '../viewVehicle.description'

const DataView = ({ partData }) => {
  const { t } = useTranslations()

  const { dataViewInfo } = partData || []

  const translationKeys = {
    Steel: 'job_Steel',
    Aluminium: 'job_Aluminium',
    Nickel: 'job_Nickel',
    Copper: 'job_Copper',
    Plastic: 'job_Plastic',
    Rubber: 'job_Rubber',
    ELV: 'job_ELV',
    Bale: 'job_Bale',
    'Steel Bar': 'job_SteelBar',
    Body: 'inv_Body',
    known: 'inv_Known',
    traced: 'inv_Traced',
    'estimated and certified': 'inv_EstimatedAndCertified',
    Mining: 'job_Mining',
    'Iron Ore': 'job_IronOre',
    Refining: 'job_Refining',
    'Refined Iron Ore': 'job_RefinedIronOre',
    'Sponge Iron': 'job_SpongeIron',
    'Aluminium Bar': 'job_AluminiumBar',
    'Engine Block': 'inv_EngineBlock',
    Engine: 'job_Engine',
    'Bauxite Ore': 'job_BauxiteOre',
    'Alumina/Aluminium Oxide': 'job_AluminaAluminiumOxide',
    'Pure Aluminium': 'job_PureAluminium',
    'Cylinder Head': 'inv_CylinderHead',
    Crankshaft: 'inv_Crankshaft',
    'Refined Iron': 'job_RefinedIron',
    'Spark Plug': 'job_SparkPlug',
    Bearings: 'inv_Bearings',
    'Exhaust System': 'job_ExhaustSystem',
    Gasket: 'job_Gasket',
    'Lead (Recovered)': 'inv_LeadRecovered',
    'Lead (Recycled)': 'inv_LeadRecycled',
    'Cathode + (Lead Oxide)': 'inv_CathodeLeadOxide',
    'Anode - (Metallic Lead)': 'inv_AnodeMetallicLead',
    Cell: 'inv_Cell',
    Module: 'inv_Module',
    Battery: 'job_Battery',
    'Lead Ore': 'inv_LeadOre',
    'Refined Lead': 'inv_RefinedLead',
    'Metallic Lead': 'inv_MetallicLead',
    'Sulfide Ore': 'inv_SulfideOre',
    'Refined Sulfur': 'inv_RefinedSulfur',
    'Sulfuric Acid': 'inv_SulfuricAcid',
    'Metallic Lead (Pb)': 'inv_MetallicLeadPb',
  }

  const renderTranslationFn = rowData => t(translationKeys[rowData] ?? rowData)

  const columns = [
    {
      title: t('inv_SrNo'),
      key: 'Sr.No.',
      render: (rowData, _, index) => {
        return index + 1
      },
    },
    {
      title: t('inv_ValueChain'),
      key: 'Value Chain',
      dataIndex: 'valueChain',
      render: renderTranslationFn,
    },
    {
      title: t('inv_Identity'),
      key: 'Identity',
      dataIndex: 'identity',
      render: renderTranslationFn,
    },
    {
      title: t('inv_MaterialFlow'),
      key: 'Material Flow',
      dataIndex: 'materialFlow',
      render: renderTranslationFn,
    },
    {
      title: t('vhc_GHGEmissions'),
      key: 'GHG Emissions',
      dataIndex: 'ghgEmissions',
      render: renderTranslationFn,
    },
    {
      title: t('inv_ESGData'),
      key: 'ESG Data',
      dataIndex: 'esgData',
      render: renderTranslationFn,
    },
  ]

  const tableViewUI = useCallback(
    ({ dataSource }) => (
      <ANTDTable
        className="mb-20"
        dataSource={dataSource.map((val, index) => ({
          ...val,
          key: index,
        }))}
        columns={columns}
        pagination={false}
        scroll={{ x: '100%' }}
        // loading={loader}
      />
    ),
    [],
  )

  return (
    <>
      {dataViewInfo?.map(({ ratio, material }, ind) => (
        <Fragment key={ind}>
          <h3>
            {t(provenanceTitles?.[ind])}
            <span style={{ marginLeft: '30px' }}>
              {t(translationKeys[material] || material)}
            </span>
          </h3>
          {isArray(ratio) &&
            ratio?.map(({ subTitle, dataSource }, index) => (
              <Fragment key={index}>
                <p className="mb-10">{subTitle}</p>
                {tableViewUI({ dataSource })}
              </Fragment>
            ))}
        </Fragment>
      ))}
    </>
  )
}

export default DataView
